<template>
  <div class="widget-table">
    <DataTable
      v-if="items && items.length"
      :value="items"
      :columns="dimensionComp"
      theme="border"
      :class="['widget-table-component', total ? 'widget-table-total' : '']"
      :cellWrapper="cellWrapper"
      :rowWrapper="rowWrapper"
      :sortable-by="sortableBy"
      :sort-by.sync="sort"
    >
      <template v-for="dimension in dimensionComp" v-slot:[dimension.id]="{ item, rowIndex, colIndex }">
        <!-- TODO: Code that handles Collapsible (Not in use) -->
        <!-- <div v-if="dimension.id === 'primary-row-actions'">
          <ButtonComponent
            tag="router-link"
            v-tooltip="$t('residentialAccount')"
            :icon="['fal', 'home']"
            :to="{ name: 'residential-edit', params: { id: item.id, step: 'residential-account' } }"
          />
        </div> -->

        <!-- <div
          v-if="!item.appended && source.collapsible && colIndex === 0"
          class="widget-table-collapsible__triggers"
          :key="dimension.id"
          @click="() => handleCollapse(item, rowIndex)"
        >
          <FontAwesomeIcon v-if="item.toggled" :icon="['fas', 'chevron-down']" />
          <FontAwesomeIcon v-else :icon="['fas', 'chevron-right']" />
          <span>{{ dimension.value(source, data, item) }}</span>
        </div>
        <div
          v-else
          :key="dimension.id"
          :class="[item.appended && colIndex === 0 ? 'widget-table-collapsible__data' : '']"
        >
          <component
            v-if="dimension.component && dimension.component({ item })"
            :key="dimension.id"
            :is="dimension.component({ item }).component || 'div'"
            :row-index="rowIndex"
            :col-index="colIndex"
            v-bind="dimension.component({ item }).props"
            v-on="dimension.component({ item }).listeners"
          >
            {{ dimension.component({ item }).value || dimension.value({ source, data, item }) }}
          </component>
          
        </div> -->
        <span v-if="isTotalRow(rowIndex)" :key="dimension.id"
          ><span v-if="total.label && colIndex === 0">{{
            total.label === true || total.label === 'true' ? $t('total') : total.label
          }}</span>
          <span v-else>{{ totalValueComp({ item, dimension }) }}</span></span
        >
        <span
          v-else
          :key="dimension.id"
          :class="`${
            valueComp({ source, dimension, data, item }) ? 'widget-table-data' : 'widget-table-data__missing'
          }`"
          >{{ valueComp({ source, dimension, data, item }) || $t('statisticsEmptyState') }}</span
        >
      </template>
      <template #primary-row-actions="{ item, rowIndex }" v-for="(action, index) in actions">
        <ButtonComponent
          v-if="!isTotalRow(rowIndex)"
          :key="`${action.id}-${index}`"
          tag="router-link"
          v-tooltip="$t(action.toolTip || '')"
          :icon="action.icon || ''"
          :to="action.to({ item })"
        />
      </template>
    </DataTable>
    <component v-else :is="fallback.tag || 'p'" v-bind="fallback.props">{{ fallback.label }}</component>
    <footer v-if="items && items.length">
      <component v-if="footerComp.component" :is="footerComp.component" v-bind="footerComp.props">{{
        footerComp.label
      }}</component>
      <span v-else>{{ footerComp }}</span>
    </footer>
  </div>
</template>

<script>
import DataTable from '@/components/DataTable'
import { SortWatcher, getSort } from '@/components/Sort'
import tracker from '@/tracking'

export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    source: Object,
  },
  watch: {
    ...SortWatcher('sortFunction'),
    data: {
      handler: 'setItems',
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      sort: this.source.sort || {},
      items: [],
    }
  },
  computed: {
    dimensionComp() {
      return this.dimensions.filter(dimension => {
        return (
          this.items &&
          this.items.filter(
            item =>
              (
                Object.entries(item).filter(
                  ([key, value]) =>
                    dimension.id === key && !['', undefined, null, 'undefined', false, 'false'].includes(value),
                ) || []
              ).length > 0,
          ).length > 0
        )
      })
    },
    footerComp() {
      if (!this.source.footer) return
      return typeof this.source.footer === 'function'
        ? this.source.footer({ data: this.data, source: this.source })
        : this.source.footer
    },
    isSortable() {
      return this.source.sortableBy && this.source.sort
    },
    sortableBy() {
      return this.source.sortableBy || []
    },
    actions() {
      if (!this.source || !this.data || !this.source.actions) return
      return typeof this.source.actions === 'function'
        ? this.source.actions({ data: this.data, source: this.source })
        : this.source.actions
    },
    dimensions() {
      if (!this.source || !this.data) return
      return typeof this.source.dimensions === 'function'
        ? this.source.dimensions({ data: this.data, source: this.source })
        : this.source.dimensions
    },
    total() {
      if (!this.source || !this.data || !this.source.total) return
      return typeof this.source.total === 'function'
        ? this.source.total({ data: this.data, source: this.source })
        : this.source.total
    },
    fallback() {
      if (!this.source.fallback) return { label: this.$t('statisticsEmptyState') }
      return typeof this.source.fallback === 'function'
        ? this.source.fallback({ data: this.data, source: this.source })
        : this.source.fallback
    },
  },
  methods: {
    valueComp({ dimension, item }) {
      return dimension && dimension.value ? dimension.value({ source: this.source, data: this.data, item }) : null
    },
    totalValueComp({ dimension, item }) {
      if (this.total.value) return this.total.value({ total: this.total, item, dimension })
      return this.total.keys.includes(dimension.id) ? dimension.value({ item }) : null
    },
    isTotalRow(rowIndex) {
      return this.total && this.isLastRow(rowIndex)
    },
    isLastRow(rowIndex) {
      return this.items.length - 1 === rowIndex
    },
    handleCollapse(item, rowIndex) {
      const action = !item.toggled ? 'add' : 'remove'
      if (!this.source || !this.source.collapsible || !this.source.collapsible[action]) return

      this.source.collapsible[action].call(this, {
        rowIndex,
        item,
        items: this.items,
        data: this.data,
      })
    },
    cellWrapper(item, col) {
      if (!this.source || !this.source.cellWrapper) {
        return {
          component: 'div',
        }
      }
      return this.source.cellWrapper(item, col)
    },
    rowWrapper(item, rowIndex) {
      if (!this.source || !this.source.rowWrapper) {
        return {
          component: 'div',
        }
      }

      return this.source.rowWrapper({
        item,
        rowIndex,
        source: this.source,
        items: this.items,
        data: this.data,
        tableContext: this,
      })
    },
    sortFunction() {
      if (!this.isSortable) return this.items
      let total = null
      let itemsCopy = this.items
      if (this.total) {
        total = itemsCopy.splice(-1)
      }

      tracker.emit('Analytics:sort', {})

      const sortingKey = getSort.call(this)

      if (this.source.sortFunc) {
        this.items = [...this.source.sortFunc(itemsCopy, sortingKey), ...total].filter(Boolean)
        return
      }

      function compare(a, b, key) {
        if (a[key] < b[key]) {
          return -1
        }
        if (a[key] > b[key]) {
          return 1
        }
        return 0
      }

      Object.entries(sortingKey).forEach(([key, value]) => {
        this.items = [
          ...itemsCopy.sort((a, b) => (value > 0 ? compare(a, b, key) : compare(b, a, key))),
          ...total,
        ].filter(Boolean)
      })
    },
    setItems() {
      if (!this.source || !this.data || !this.source.data) return
      this.items = [
        ...this.source.data({ data: this.data, source: this.source }),
        this.total && this.total.data ? this.total.data : null,
      ].filter(Boolean)
    },
  },
  mounted() {
    this.sort = this.source.sort || {}
  },
  components: {
    DataTable,
  },
}
</script>

<style lang="scss">
.widget-table {
  width: 100%;
  //height: 100%;
  overscroll-behavior: contain;
  overflow-y: auto;
  overflow-x: auto;

  @include scrollShadow();
  @include respond-below('phone') {
    max-width: calc(100vw - 8rem);
  }
  .data-table__cell {
    align-items: start;
  }
  &-collapsible {
    &__triggers {
      display: flex;
      gap: 0.5rem;
      align-items: center;
      cursor: pointer;
    }
    &__data {
      padding-left: 1.5rem;
    }
  }

  [data-appended='true'] {
    background-color: #f9f9f9;
  }
  &-data {
    &__missing {
      font-size: 0.8rem;
      color: #000;
      opacity: 0.4;
    }
  }
  footer {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 1rem;
  }
}
.widget-table-total {
  .data-table__row:last-of-type {
    .data-table__row-wrapper {
      .data-table__cell {
        border-top: 1px solid #aeb2b6;
        border-bottom: 1px solid #aeb2b6;
        background-color: #f5f5f5;
      }
    }
  }
}
</style>
